module.exports = __webpack_public_path__ + "static/media/PLANTA.1230fd2e.png";